import * as Icon from './components/icons';

export const Data = [
    {
        IconComponent: Icon.Chemical,
        label:
            'Chemicals, including splashes, permeation, chemical burns or potentially slippery surfaces',
        copy: "I'm exposed to:",
        options: [
            {
                option: 'Acids, ammonia, fertilizers, milk, ethylene glycol, or caustic soda?',
                outcome: {
                    label: 'Footwear with chemical-resisting sole ',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6y',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts6y',
                            label: 'Shop plain toe options',
                        },
                    ],
                    infobit:
                        "If you'll also be exposed to any falling objects or tools that may strike the feet, choose a chemical-resistant sole with protective toe.",
                },
            },
            {
                option: 'Oils, blood, or petroleum? ',
                outcome: {
                    label: 'Footwear with chemical-resisting sole ',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6y',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts6y',
                            label: 'Shop plain toe options',
                        },
                    ],
                    infobit:
                        "If you'll also be exposed to any falling objects or tools that may strike the feet, choose a chemical-resistant sole with protective toe.",
                },
            },
            {
                option: 'Chemicals like coolant, oil, or grease?',
                outcome: {
                    label:
                        'Footwear with chemical-resisting sole and "better" or "best" slip resistance',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6yZ1yzts6hZ1yzts6s',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts6yZ1yzts6hZ1yzts6s ',
                            label: 'Shop plain toe options',
                        },
                    ],
                    infobit:
                        "If you'll also be exposed to any falling objects or tools that may strike the feet, choose a chemical-resistant sole with protective toe.",
                },
            },
            {
                option: 'Frequent immersions or chemical and liquid splashes',
                outcome: {
                    label: '8-inch work boots with chemical resisting sole ',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6yZ1yzt6jy',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts6yZ1yzt6jy',
                            label: 'Shop plain toe options',
                        },
                    ],
                    infobit:
                        "If you'll also be exposed to any falling objects or tools that may strike the feet, choose a chemical-resistant sole with protective toe.",
                },
            },
        ],
    },
    {
        IconComponent: Icon.ColdWeather,
        label: 'Cold weather, cold environments',
        copy: "Which best describes the environment you'll face?",
        options: [
            {
                option:
                    'Standing for prolonged periods in cold temperatures, such as a refrigerated area',
                outcome: {
                    label: 'Insulated waterproof footwear',
                    photo: 'images/Military.svg',
                    infobit:
                        'Will you be walking or moving excessively? Insulation adds bulk, which can make a shoe more cumbersome, so choose products that have a polyurethane and rubber outsole to reduce weight of the footwear. All-rubber outsoles are heavier. Waterproofing is a plus because "dry feet are happy feet," especially in the cold.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1z0bs6fZ1z0nmv8',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1z0bs6fZ1z0nmv8',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Extreme temperatures (-10F or lower)',
                outcome: {
                    label: 'Insulated waterproof footwear with composite toe',
                    photo: 'images/Rubber.svg',
                    infobit:
                        'Will you be walking or moving excessively? Insulation adds bulk, which can make a shoe more cumbersome, so choose products that have a polyurethane and rubber outsole to reduce weight of the footwear. All-rubber outsoles are heavier. Waterproofing is a plus because "dry feet are happy feet," especially in the cold.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1z0bs6fZ1z0crpnZ1z0nmv8',
                            label: 'Shop protective toe options ',
                        },
                    ],
                },
            },
            {
                option: 'Exposure to chemicals, as well as extreme cold temperatures ',
                outcome: {
                    label: 'Insulated waterproof footwear with chemical resisting sole',
                    photo: 'images/Rubber.svg',
                    infobit:
                        'Will you be walking or moving excessively? Insulation adds bulk, which can make a shoe more cumbersome, so choose products that have a polyurethane and rubber outsole to reduce weight of the footwear. All-rubber outsoles are heavier. Waterproofing is a plus because "dry feet are happy feet," especially in the cold.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6yZ1z0bs6fZ1z0crpnZ1z0nmv8',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts6yZ1z0bs6fZ1z0nmv8',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Wet conditions ',
                outcome: {
                    label: 'Insulated waterproof footwear',
                    photo: 'images/Rubber.svg',
                    infobit:
                        'Will you be walking or moving excessively? Insulation adds bulk, which can make a shoe more cumbersome, so choose products that have a polyurethane and rubber outsole to reduce weight of the footwear. All-rubber outsoles are heavier. Waterproofing is a plus because "dry feet are happy feet," especially in the cold.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1z0bs6fZ1z0nmv8',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1z0bs6fZ1z0nmv8',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Icy conditions',
                outcome: {
                    label: 'Insulated waterproof footwear with "better" or "best" slip resistance',
                    photo: 'images/Rubber.svg',
                    infobit:
                        'Will you be walking or moving excessively? Insulation adds bulk, which can make a shoe more cumbersome, so choose products that have a polyurethane and rubber outsole to reduce weight of the footwear. All-rubber outsoles are heavier. Waterproofing is a plus because "dry feet are happy feet," especially in the cold.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1z0bs6fZ1yzts6hZ1yzts6sZ1z0nmv8',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1z0bs6fZ1yzts6hZ1yzts6sZ1z0nmv8',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Punctures,
        label: 'Punctures',
        copy: "I'm exposed to areas where:",
        options: [
            {
                option:
                    'Sharp or protruding objects are likely to be present on the floors or surfaces',
                outcome: {
                    label:
                        'Footwear with built-in puncture-resistance, or puncture-resistant insoles',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6m',
                            label: 'Shop protective toe options',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts6m',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Metal pieces may degrade, or damage soles of boots or shoes',
                outcome: {
                    label: 'Footwear with metal-chip-resistant outsoles ',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts5l',
                            label: 'Shop protective toe options',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts5l',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Puncture potential from sharp and metal objects is high',
                outcome: {
                    label:
                        'Footwear with built-in puncture-resistance, or metal-chip-resistant outsoles with puncture-resistant insoles',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts5lZ1yzts6m',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Explosives,
        label: 'Explosives or flammables',
        copy: 'I work with: ',
        options: [
            {
                option: 'Explosives or highly flammable or volatile chemicals',
                outcome: {
                    label: 'Conductive safety footwear',
                    photo: 'images/Generic.svg',
                    infobit:
                        'Silk, wool and nylon socks should not be worn in this type of work environment or with this type of shoe, as those materials are more likely to produce static as well. <p>Do you also work in electrically hazardous environments? Never wear conductive shoes in these environments, as the conductive shoe will not offer protection to electrical hazards such as shock or electrocution. <strong>Note:</strong> In electrically hazardous environments, choosing the wrong footwear can have serious consequences. Consult a safety specialist with any questions.</p>',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yztryv',
                            label: 'Shop protective toe options',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yztryv',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Electrical,
        label: 'Electrical',
        copy: "I'm exposed to: ",
        options: [
            {
                option: 'Possible electrical hazards',
                outcome: {
                    label: 'Electrical hazard (EH) rated footwear',
                    photo: 'images/Generic.svg',
                    infobit:
                        'Electrical hazard-rated shoes carry the ASTM designation (EH), which shows products designed to protect wearers from up to 600 volts in a dry setting. Electrical hazard resistant footwear must withstand the application of 18,000 volts rms with current flow no greater than 60 hertz for one minute under dry conditions. <p> Never use EH for wet electrical areas or high voltage. Note: In electrically hazardous environments, choosing the wrong footwear can have serious consequences. Consult a safety specialist with any questions.</p>',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-shoes and boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6v',
                            label: 'Shop protective toe options',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts6v',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Wet environments with electrical and high voltage exposure',
                outcome: {
                    label: 'Dielectric overboots and overshoes ',
                    photo: 'images/Rubber.svg',
                    infobit:
                        'Never use EH for wet electrical areas or high voltage. <strong>Note:</strong> In electrically hazardous environments, choosing the wrong footwear can have serious consequences. Consult a safety specialist with any questions. ',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/dielectric-footwear/footwear-and-footwear-accessories/safety/ecatalog/N-ip9',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Sparks,
        label: 'Sparks, static discharge',
        copy: 'Will you: ',
        options: [
            {
                option:
                    'Work around computer components or in a facility that can generate static through manufacturing?',
                outcome: {
                    label: 'Static-dissipative footwear',
                    photo: 'images/Athletic.svg',
                    infobit:
                        'Static-dissipative (SD) footwear is designed to reduce static on the body and release that energy to the ground.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yztryu',
                            label: 'Shop protective toe options',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yztryu',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Be exposed to falling objects that could strike your feet?',
                outcome: {
                    label: 'Static-dissipative shoes with protective toe',
                    photo: 'images/Athletic.svg',
                    infobit:
                        'Static-dissipative (SD) footwear is designed to reduce static on the body and release that energy to the ground.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yztryu',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.HighSecurity,
        label: 'High security',
        copy: 'Will you: ',
        options: [
            {
                option: 'Pass through a metal detector frequently?',
                outcome: {
                    label: 'Completely nonmetallic footwear (security-friendly)',
                    photo: 'images/Generic.svg',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts5j',
                            label: 'Shop protective toe options',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts5j',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
            {
                option: 'Be exposed to falling objects that could strike your feet?',
                outcome: {
                    label:
                        'Completely nonmetallic footwear (security-friendly) with composite toe ',
                    photo: 'images/Generic.svg',
                    infobit: 'Footwear designed to protect feet from crushing injuries.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts5j',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
            {
                option: 'Be walking or standing on slick or slippery work surfaces?',
                outcome: {
                    label:
                        'Completely nonmetallic footwear (security-friendly) with slip resistance ',
                    photo: 'images/Generic.svg',
                    infobit:
                        'When shopping for footwear on Grainger.com, set the slip-resistance filter to "better" or "best" for maximum protection from falls.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts5jZ1yzts6hZ1yzts6s',
                            label: 'Shop protective toe options',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzts5jZ1yzts6hZ1yzts6s',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Cuts,
        label: 'Cuts, amputation, crushing injuries',
        copy: 'Will you: ',
        options: [
            {
                option: 'Be operating a chainsaw?',
                outcome: {
                    label: 'Chainsaw cut-resistant boot',
                    photo: 'images/Chainsaw.svg',
                    infobit:
                        'This footwear is designed to protect the feet against contact with a running chainsaw.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzts6z?pfDimension=ShoeFinderViewAll&pfCategory=Steel-Toe+Work+Boots+and+Shoes&source=ProductFinder-ShoeFinder&pfCategoryType=Shoe&pfRecentFilter=Chain+Saw+Cut+Resistant%3AYes',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Heights,
        label: 'Ladders or poles ',
        copy: 'Will you: ',
        options: [
            {
                option: 'Be exposed to electrical hazards?',
                outcome: {
                    label: 'Linesman or logger boots with composite toe ',
                    photo: 'images/Linesman.svg',
                    infobit: 'This offers significantly better resistance to electrical hazards.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzt6hmZ1yzt6jwZ1z0crpn',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
            {
                option: 'Be exposed to wet conditions?',
                outcome: {
                    label: 'Waterproof linesman and logger boots ',
                    photo: 'images/Linesman.svg',
                    infobit:
                        'Remember, to prevent bulk in climbing, most linesman boots are not insulated, so be sure to select a fit that allows room for thick warm socks for colder weather exposure.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzt6hmZ1yzt6jwZ1z0crpn',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Office,
        label: 'General hazards with professional dress standards',
        copy: 'Do you: ',
        options: [
            {
                option:
                    'Work in an office setting that requires professional or “business casual” clothing, but also in setting where protective footwear is necessary?',
                outcome: {
                    label: 'Dress or casual safety shoes ',
                    photo: 'images/Athletic.svg',
                    infobit:
                        'This footwear offers a professional appearance, as well as protection for the feet.',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzt6hqZ1yzt6jr',
                            label: 'Shop protective toe options',
                        },
                    ],
                },
            },
        ],
    },
    {
        IconComponent: Icon.Outdoor,
        label: 'Outdoor terrain, uneven or wet conditions',
        copy: 'Do you: ',
        options: [
            {
                option: 'Work in forestry or logging?',
                outcome: {
                    label: 'Logging boot',
                    photo: 'images/Logger.svg',
                    infobit:
                        'This footwear offers extra traction built in on the soles, or a safety hiking boot for added comfort and versatility. ',
                    links: [
                        {
                            link:
                                'https://www.grainger.com/category/steel-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipoZ1yzt6jw',
                            label: 'Shop protective toe options ',
                        },
                        {
                            link:
                                'https://www.grainger.com/category/plain-toe-work-boots-and-shoes/footwear-and-footwear-accessories/safety/ecatalog/N-ipjZ1yzt6jw',
                            label: 'Shop plain toe options',
                        },
                    ],
                },
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/data.js